import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { CheckboxModule } from 'primeng/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PmAsteriskComponent } from '../pm-asterisk/pm-asterisk.component';
import { PmLinkComponent } from '@shared/components/pm-link/pm-link.component';

@Component({
  standalone: true,
  selector: 'pm-form-field-checkbox',
  imports: [
    CheckboxModule,
    ReactiveFormsModule,
    CommonModule,
    PmAsteriskComponent,
    PmLinkComponent,
  ],
  templateUrl: './pm-form-field-checkbox.component.html',
  styleUrl: './pm-form-field-checkbox.component.scss',
})
export class PmFormFieldCheckboxComponent extends FormFieldComponent {}
